import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import OverviewTab from "../tab-overview/tab-overview";
import styles from "./section-tabs.module.scss";
import OrdersTab from "../tab-orders/tab-orders";

const TabsSection = () => {

  return (
    <div className={styles['section']}>
      <Tabs className={styles['section-tabs']} defaultActiveKey='security-overview'>
        <Tab tabClassName={`${styles['tab']}`} eventKey="security-overview" title="Overview">
          <OverviewTab />
        </Tab>
        <Tab tabClassName={styles['tab']} eventKey="security-orders" title="Reservations">
          <OrdersTab />
        </Tab>
        {/*<Tab tabClassName={styles['tab']} eventKey="security-investors" title="Investors">*/}
        {/*</Tab>*/}
      </Tabs>
    </div>
  )
}

export default TabsSection;
